import { ChannelAppTabAction } from '../../services';
import { layoutPath } from './layoutPath';

interface GetAppTabHrefByActionTypeArgs {
  actionType: ChannelAppTabAction;
  storyId?: number;
}

export const getAppTabHrefByActionType = ({
  actionType,
  storyId,
}: GetAppTabHrefByActionTypeArgs) => {
  switch (actionType) {
    case ChannelAppTabAction.STORIES:
      return layoutPath('/storyTab1');
    case ChannelAppTabAction.STORIES_2:
      return layoutPath('/storyTab2');
    case ChannelAppTabAction.STORIES_3:
      return layoutPath('/storyTab3');
    case ChannelAppTabAction.STORIES_4:
      return layoutPath('/storyTab4');
    case ChannelAppTabAction.STORIES_5:
      return layoutPath('/storyTab5');
    case ChannelAppTabAction.PROFILE:
      return layoutPath('/profile');
    case ChannelAppTabAction.PINNED_STORY:
      return storyId ? layoutPath(`/pinnedStoryTab/${storyId}/items`) : layoutPath('/');
    case ChannelAppTabAction.PINNED_STORY_2:
      return storyId ? layoutPath(`/pinnedStoryTab2/${storyId}/items`) : layoutPath('/');
    case ChannelAppTabAction.PINNED_STORY_3:
      return storyId ? layoutPath(`/pinnedStoryTab3/${storyId}/items`) : layoutPath('/');
    case ChannelAppTabAction.PINNED_STORY_4:
      return storyId ? layoutPath(`/pinnedStoryTab4/${storyId}/items`) : layoutPath('/');
    case ChannelAppTabAction.PINNED_STORY_5:
      return storyId ? layoutPath(`/pinnedStoryTab5/${storyId}/items`) : layoutPath('/');
    case ChannelAppTabAction.CHATS:
      return layoutPath('/chats');
    case ChannelAppTabAction.USER_DIRECTORY:
      return '/userDirectory';
    case ChannelAppTabAction.BOOKMARKS:
      return '/bookmarks';
    case ChannelAppTabAction.EVENTS:
      return '/events';
    default:
      return layoutPath('/');
  }
};
